/*! GW Wishlist extras | Godha World. Animations, product-page touches, variant memory, homepage strip, price-drop nudge, analytics.
 *  Pure add-on: reads state from GWWishInternal, touches no checkout/cart/GoKwik/AiSensy code. */
(function () {
  'use strict';
  var W = window, D = document;
  function dl(ev, d) { try { var o = { event: ev, event_id: 'gw' + Date.now() + Math.random().toString(36).slice(2, 7), timestamp: new Date().toISOString() }; for (var k in d) o[k] = d[k]; (W.dataLayer = W.dataLayer || []).push(o); } catch (e) {} }
  function pulse(el, cls, ms) { if (!el) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); setTimeout(function () { el.classList.remove(cls); }, ms || 700); }

  function start(G) {
    var $ = G.$, $$ = G.$$, esc = G.esc, read = G.read, write = G.write, money = G.money, img = G.img;
    var prev = G.handles().slice(), stripEl = null;

    /* ----- reactions to save / remove ----- */
    D.addEventListener('gw:wishlist', function () {
      var now = G.handles(), added = now.filter(function (h) { return prev.indexOf(h) < 0; }), removed = prev.filter(function (h) { return now.indexOf(h) < 0; });
      prev = now.slice();
      if (added.length) {
        $$('.wbwishcount').forEach(function (c) { pulse(c.closest('a'), 'gw-bump', 650); });
        added.forEach(function (h) { $$('.gw-wish-btn').forEach(function (b) { if (b.getAttribute('data-gw-handle') === h) pulse(b, 'gw-burst', 650); }); dl('wishlist_item_added', { product_handle: h, currency: (W.Shopify && W.Shopify.currency && W.Shopify.currency.active) || 'INR', wishlist_count: now.length }); });
      }
      removed.forEach(function (h) { dl('remove_from_wishlist', { ecommerce: { items: [{ item_id: h }] } }); dl('wishlist_item_removed', { product_handle: h, wishlist_count: now.length }); });
      pdpNote(); strip();
    });

    /* ----- product page ----- */
    var pdpH = null, curPrice = null, nudged = false;
    if (/template-product/.test(D.body.className)) { var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (m) pdpH = decodeURIComponent(m[1]); }

    /* remember the exact variant the customer saved */
    function curVariantId() { var i = $('product-form input[name="id"]'); return i && i.value; }
    function stampVariant() {
      if (!pdpH) return; var i = G.idx(pdpH); if (i < 0) return; var v = curVariantId();
      if (v && String(G.list[i].v) !== String(v)) { G.list[i].v = v; G.save(); }
    }
    D.addEventListener('gw:wishlist', stampVariant);
    D.addEventListener('change', function (e) { if (pdpH && e.target.closest && e.target.closest('product-form, form[action*="/cart/add"]')) setTimeout(stampVariant, 80); });

    function pdpNote() {
      if (!pdpH) return; var b = $('.gw-wish-btn--pdp'); if (!b) return;
      var n = $('.gw-pdp-note'); if (!n) { n = D.createElement('p'); n.className = 'gw-pdp-note'; b.parentNode.insertBefore(n, b.nextSibling); }
      var i = G.idx(pdpH), html = '';
      if (i > -1) {
        var saved = G.list[i].p;
        if (saved && curPrice != null && curPrice < saved) html += '<span class="gw-pdp-note__drop">Price dropped ' + money(saved - curPrice) + ' since you saved it</span> &middot; ';
        html += '<a href="/pages/wishlist">View wishlist (' + G.list.length + ')</a>';
      }
      n.innerHTML = html; n.classList.toggle('is-on', !!html);
    }
    function pdpInit(tries) {
      if (!pdpH) return; var b = $('.gw-wish-btn--pdp');
      if (!b) { if (tries < 12) setTimeout(function () { pdpInit(tries + 1); }, 400); return; }
      G.getMany([pdpH]).then(function (ps) {
        var p = ps[0];
        if (p) { curPrice = p.price; if (!p.available && G.CFG.webhook && read(G.KEYS.O, null)) b.classList.add('gw-soldout'); }
        pdpNote();
      });
      b.addEventListener('click', function () { nudged = true; });
      setTimeout(function () { if (!nudged && !b.classList.contains('is-active')) pulse(b, 'gw-nudge', 1600); }, 5000);
    }
    pdpInit(0);

    /* ----- homepage: "Your wishlist" strip for returning visitors ----- */
    function strip() {
      if (!/template-index/.test(D.body.className)) return;
      var hs = G.handles().slice(0, 10);
      if (!hs.length) { if (stripEl) { stripEl.remove(); stripEl = null; } return; }
      if (!stripEl) {
        var foot = $('#shopify-section-footer') || $('footer'); if (!foot) return;
        stripEl = D.createElement('section'); stripEl.className = 'gw-strip'; foot.parentNode.insertBefore(stripEl, foot);
      }
      G.getMany(hs).then(function (ps) {
        if (!stripEl) return;
        stripEl.innerHTML = '<div class="gw-strip__in"><div class="gw-strip__hd"><h3>Your wishlist <span>(' + G.list.length + ')</span></h3><a href="/pages/wishlist">View all</a></div><div class="gw-strip__row">' +
          ps.map(function (p) { return '<a class="gw-mini" href="' + esc(p.url) + '"><span class="gw-mini__img">' + (p.image ? '<img loading="lazy" alt="" src="' + esc(img(p.image, 240)) + '">' : '') + '</span><span class="gw-mini__t">' + esc(p.title) + '</span><span class="gw-mini__p">' + money(p.price) + '</span></a>'; }).join('') + '</div></div>';
      });
    }
    strip();

    /* ----- once-a-day "price dropped" nudge (never interrupts another toast or the wishlist page) ----- */
    setTimeout(function () {
      if (!G.list.length || /\/pages\/wishlist/.test(location.pathname) || D.querySelector('.gw-toast.is-on')) return;
      var d = read('gw_wl_drops_v1', null); if (!d || !d.n || Date.now() - d.t > 24 * 3600 * 1000) return;
      var today = new Date().toISOString().slice(0, 10); if (read('gw_wl_drop_toast', null) === today) return;
      write('gw_wl_drop_toast', today);
      G.toast('Price dropped on ' + d.n + ' saved item' + (d.n > 1 ? 's' : ''), 'View', null, '/pages/wishlist');
    }, 6500);
  }

  function go(n) {
    var G = W.GWWishInternal;
    if (!G) { if (n < 40) setTimeout(function () { go(n + 1); }, 100); return; }
    if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { start(G); }); else start(G);
  }
  go(0);
})();